/**
 * L.O.T.S. (FT-1461): A LOT'S LIVE ABILITY, chosen by the player's TEAM.
 *
 * The keystone of the L.O.T.S. divergence from BotC: a Lot (role) is NOT tied
 * to a team. Every Lot carries two abilities — a Light side (`role.ability`)
 * and a Shadow side (`role.shadowAbility`) — and which one is live is decided
 * by the SEAT's own alignment (`player.alignment`), an independent per-seat
 * value the Reader sets.
 *
 * This is pure and read-on-demand by design: the selection is DERIVED on every
 * render, never snapshotted at deal time, so the instant anything moves a
 * seat's alignment (the Reader by hand, an ability, the Cross) the shown
 * ability follows with no re-deal.
 *
 * Do NOT confuse the alignment axis (Light|Shadow, the player's side) with
 * `role.team` (townsfolk|outsider|minion|demon, the card's spread category).
 */

/** The two alignment values a seat can hold once the Reader assigns one.
 *  `null` is the third, unset, state — an undealt or not-yet-sided seat. */
export const LIGHT = "light";
export const SHADOW = "shadow";

/**
 * The ability text a Lot shows for a seat on the given alignment.
 *
 *   Light (or unset) → the role's own `ability`
 *   Shadow           → the role's `shadowAbility`, falling back to `ability`
 *                      when the Shadow side is empty (placeholder data exists)
 *
 * @param {object} role       a role object, or null/{} for an empty chair
 * @param {string|null} alignment  LIGHT | SHADOW | null
 * @returns {string} the live ability text (empty string when there is none)
 */
export function abilityFor(role, alignment) {
  if (!role) return "";
  if (alignment === SHADOW) return role.shadowAbility || role.ability || "";
  return role.ability || "";
}

/**
 * The next alignment for the Reader's one-click control: it SETS on the first
 * press and FLIPS after — unset → Light → Shadow → Light → …. One control
 * that both assigns and toggles, so a seat never needs a second gesture.
 *
 * @param {string|null} alignment the seat's current alignment
 * @returns {string} LIGHT or SHADOW
 */
export function nextAlignment(alignment) {
  return alignment === LIGHT ? SHADOW : LIGHT;
}
